import type { SxProps, Theme } from '@mui/material';

/** WDUI geo-event tabs: single tab stays half-width; multiple tabs share the row. */
const SINGLE_TAB_WIDTH = '50%';

export const getWduiTabWidthSx = (enabledTabCount: number): SxProps<Theme> => {
  if (enabledTabCount < 1) {
    return {};
  }

  if (enabledTabCount === 1) {
    return {
      flex: `0 0 ${SINGLE_TAB_WIDTH}`,
      minWidth: SINGLE_TAB_WIDTH,
      maxWidth: SINGLE_TAB_WIDTH,
    };
  }

  return {
    flex: 1,
    maxWidth: 1 / enabledTabCount,
  };
};
